 /*
 * Javascript for the team pages
*/
(function($) {
	if($('.team-group').length) {
		$('.team-group .person').matchHeight();

		$(document).ready(function(){
			console.log('featherlight');
			$('.person').featherlightGallery({
				gallery: {
					next: 'next »',
					previous: '« previous'
				},
				previousIcon: '&#9664;',     /* Code that is used as previous icon */
				nextIcon: '&#9654;',         /* Code that is used as next icon */
				galleryFadeIn: 0,          /* fadeIn speed when slide is loaded */
				galleryFadeOut: 0,          /* fadeOut speed before slide is loaded */
				openSpeed:      150,
				closeSpeed:     150,
				//variant: 'featherlight-gallery2'
			});
		});
	}
})(jQuery);
